var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewResponseIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 20",
    width: 17,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 20,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAMAAABcfiZ7AAAAAXNSR0IB2cksfwAAAVNQTFRFICAgAAAAAAAAAAAABAQEUlJSlJSUjIyMiYmJmJiYAAAAAAAAAAAAAAAAAAAAUlJSAAAAAAAAAAAAAAAACAgIU1NTkZGRmZmZAAAAAAAAKioqODg4T09PoqKiAwMDAQEBBAQEAAAAAwMDKioqCQkJXl5eTU1NOTk5b29vT09PBgYGAAAAVVVVmZmZAAAARERE////////UVFRAAAAAAAAAAAAAAAAeHh4PT09CAgIl5eXzs7OWFhYAAAAAAAAAAAAdHR0cnJyAAAAKioqu7u7aGhoDw8PVFRUS0tLpKSkGRkZHR0dAAAAdHR02traCAgIdXV1REREAAAAAAAAGxsbsbGxLy8ve3t7aWlpAAAANjY20dHRKCgoLS0ti4uLcnJyqqqqAAAAERERAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBAQDg4OxJk4ewAAAHF0Uk5TxfP8+eltAAAAAPrWma7/bv2LACf1awAAkTJnoG4AAAAANJBf8G0AAAAq/PEABxIOAAIvOqj7jwC99DQAAIr+kABjjoUUAAAAAAAABAcBAAAArefo1BkAAHusmA8AAAAAAIwA+ELs97NPsoWDwmzB0tMhPWn9AAAA50lEQVR4nGNgYGSCAmYWVjZ2Dk4GLm4eKODl4+NnA4oICApBgTCfCJ+omDgDkwRMRJJPSppPRhYkIicP5CsIKfIpKavwqQJFFNRAIuoamlp8QKANFNHR1QMCfQNDI2NjYxNTBiYzcwuQ3ZZW1jZApbZ2DEz2Do5OQODs4urm7iFkJgDS5Qmyycvbx8fXzx8kYhYQGAQCwcHBIaFhIBH78IhIKIiKjgHrio2DuTE+QR4oIpAo5AYTSVIA2ZXMm4IMIpkZUvlQQSpDWnoGMshMZrDLEkIG2XwMTDm5yCCPiSGfkQsZMBYAACOxOexMgDbVAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewResponseIcon2);
export default __webpack_public_path__ + "static/media/reviewResponseIcon2.0165d9d40b760de74a29d9d1e50a7999.svg";
export { ForwardRef as ReactComponent };